export const CROMWELL_INTRO_LINK =
  'https://cromwell.readthedocs.io/en/stable/tutorials/FiveMinuteIntro/';
export const WORKFLOW_AND_WDL_LINK =
  'https://support.terra.bio/hc/en-us/articles/360037117492-Overview-Getting-started-with-WDL';
